



export const PROD_FIREBASE_URL = "https://us-central1-mytamatnotif.cloudfunctions.net";
export const DEV_FIREBASE_URL = "https://us-central1-mytamatnotifprototype.cloudfunctions.net";
